<script>
  /* global Global */
  export let lang = undefined;

  const CHAMPIONSHIP_DATE = new Date(Global.date.countdown);
  const MILLISECONDS_IN_SECOND = 1000;
  const SECONDS_IN_MINUTE = 60;
  const MINUTES_IN_HOUR = 60;
  const HOURS_IN_DAY = 24;
  const ONE_SECOND = MILLISECONDS_IN_SECOND;
  const ONE_MINUTE = ONE_SECOND * SECONDS_IN_MINUTE;
  const ONE_HOUR = ONE_MINUTE * MINUTES_IN_HOUR;
  const ONE_DAY = ONE_HOUR * HOURS_IN_DAY;

  let today;
  let difference;

  let days;
  let hours;
  let minutes;
  let seconds;

  function getDaysTillChampionship () {
    difference = CHAMPIONSHIP_DATE.getTime() - today.getTime();
    return Math.floor(difference / ONE_DAY);
  }

  function getHoursTillChampionship () {
    difference -= days * ONE_DAY;
    return Math.floor(difference / ONE_HOUR);
  }

  function getMinutesTillChampionship () {
    difference -= hours * ONE_HOUR;
    return Math.floor(difference / ONE_MINUTE);
  }

  function getSecondsTillChampionship () {
    difference -= minutes * ONE_MINUTE;
    return Math.floor(difference / ONE_SECOND);
  }

  (function refresh () {
    today = new Date();

    days = getDaysTillChampionship();
    hours = getHoursTillChampionship();
    minutes = getMinutesTillChampionship();
    seconds = getSecondsTillChampionship();

    setTimeout(refresh, MILLISECONDS_IN_SECOND);
  })();

  const i18n = {
    days: {
      cs: 'Dní',
      en: 'Days',
    },
    hours: {
      cs: 'Hodin',
      en: 'Hours',
    },
    minutes: {
      cs: 'Minut',
      en: 'Minutes',
    },
    seconds: {
      cs: 'Sekund',
      en: 'Seconds',
    },
  };
</script>

<div class='countdown'>
  <div class='countdown-days'>
    <div class='countdown-days-value'>
      {days}
    </div>

    <div class='countdown-days-label'>
      {i18n.days[lang]}
    </div>
  </div>

  <div class='countdown-hours'>
    <div class='countdown-hours-value'>
      {hours}
    </div>

    <div class='countdown-hours-label'>
      {i18n.hours[lang]}
    </div>
  </div>

  <div class='countdown-minutes'>
    <div class='countdown-minutes-value'>
      {minutes}
    </div>

    <div class='countdown-minutes-label'>
      {i18n.minutes[lang]}
    </div>
  </div>

  <div class='countdown-seconds'>
    <div class='countdown-seconds-value'>
      {seconds}
    </div>

    <div class='countdown-seconds-label'>
      {i18n.seconds[lang]}
    </div>
  </div>
</div>

<style>
  .countdown {
    display: flex;
    justify-content: center;
    gap: 10px;

    width: calc(100% - 120px);

    padding: 20px 60px;
  }

  .countdown-days, .countdown-hours,
  .countdown-minutes, .countdown-seconds {
    display: flex;
    flex-direction: column;

    width: 90px;
    height: 60px;
  }

  .countdown-days-value, .countdown-hours-value,
  .countdown-minutes-value, .countdown-seconds-value {
    display: flex;
    justify-content: center;
    align-items: center;

    height: 45px;

    font-family: var(--font-secondary);
    font-size: 32px;
    font-weight: bold;
  }

  .countdown-days-label, .countdown-hours-label,
  .countdown-minutes-label, .countdown-seconds-label {
    display: flex;
    justify-content: center;
    align-items: center;

    height: 15px;

    text-transform: uppercase;

    font-size: 10px;

    letter-spacing: 1.2px;

    color: var(--grey-6);
  }

  @media only screen and (max-width: 900px) {
    .countdown {
      width: calc(100% - 80px);

      padding: 20px 40px;
    }
  }

  @media only screen and (max-width: 350px) {
    .countdown {
      width: calc(100% - 40px);

      padding: 20px;
    }
  }
</style>
